import { DownOutlined, DeleteOutlined } from '@ant-design/icons';
import { Input, Space, Dropdown, Button, Popover, Divider } from 'antd';
import cn from 'classnames';
import { useEffect, useRef, useState } from 'react';

import { PF } from '@pages/Clients/NewClientsList/components/MultiFilter/data/contants';
import type { MultiFilterProps } from '@pages/Clients/NewClientsList/components/MultiFilter/types';

import type { InputRef } from 'antd';
import type { FC } from 'react';

import '@pages/Clients/NewClientsList/components/MultiFilter/styles/MultiFilter.desktop.scss';

export const MultiFilter: FC<MultiFilterProps> = ({
  label,
  selectedCount,
  rows,
  width,
  id: filterId,
  onClear,
}) => {
  const inputRef = useRef<InputRef>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);
  // const [openedPopovers, setOpenedPopovers] = useState<string[]>([]);

  useEffect(() => {
    if (!open) {
      // setOpenedPopovers([]);
    }
  }, [open]);
  return (
    <Space direction="vertical">
      <Dropdown
        open={open}
        onOpenChange={setOpen}
        trigger={['click']}
        className={`${PF}__input`}
        popupRender={() => (
          <div
            className={`${PF}__popup`}
            style={{ width: inputRef.current?.nativeElement?.offsetWidth }}
            ref={dropdownRef}
          >
            {rows.map(({ id, label, BottomContent, Content }) => (
              <div key={id} className={`${PF}__row__wrapper`}>
                <Popover
                  getPopupContainer={() => dropdownRef.current!}
                  key={id}
                  content={() => (
                    <Content open={true} id={filterId} onClose={() => {}} />
                  )}
                  trigger="click"
                  placement="right"
                  classNames={{ body: `${PF}__popover-body` }}
                  // open={openedPopovers.includes(id)}
                  onOpenChange={() => {
                    // setOpenedPopovers((prev) => {
                    //   if (isOpen) {
                    //     return [...prev, id];
                    //   }
                    //   return prev.filter((popoverId) => popoverId !== id);
                    // });
                  }}
                >
                  <div className={`${PF}__row`}>
                    {label}
                    <DownOutlined className={`${PF}__row__icon`} />
                  </div>
                </Popover>
                <BottomContent id={filterId} />
              </div>
            ))}

            <div className={`${PF}__footer`}>
              <Divider className={`${PF}__divider`} />
              <Button
                danger
                type="text"
                className={`${PF}__clear-button`}
                icon={<DeleteOutlined />}
                onClick={() => onClear(filterId)}
              >
                Очистить
              </Button>
            </div>
          </div>
        )}
      >
        <Input
          ref={inputRef}
          readOnly
          value={`${label} ${selectedCount > 0 ? `(${selectedCount})` : ''}`}
          style={{ width }}
          classNames={{ input: `${PF}__input__field` }}
          className={`${PF}__input`}
          suffix={
            <DownOutlined
              className={cn(`${PF}__input__icon`, {
                [`${PF}__input__icon--open`]: open,
              })}
            />
          }
        />
      </Dropdown>
    </Space>
  );
};
